module.exports = __webpack_public_path__ + "img/cooperation.c6f8b8a0.png";